import type { HTTPResponse, ProblemResponse } from "@/lib/http";
import type { UseMutationResult } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "sonner";

export const useNotifyMutationSuccess = <T, U>(mutation: UseMutationResult<HTTPResponse<T>, ProblemResponse, U>, title: string, description?: string) => {
	useEffect(() => {
		if (!mutation.isSuccess) {
			return;
		}

		toast.success(title, {
			description: description,
			position: "bottom-center"
		});
	}, [mutation.isSuccess]);
};
